var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlatFee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 23 Copy 3@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4.24400098e-13%",
    y1: "1.2204647e-12%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07C8F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D41E1",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Barlow-Marshall---Home-V2",
    transform: "translate(-283.000000, -964.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Companies-Box-Copy-2",
    transform: "translate(0.000000, 836.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23-Copy-3",
    transform: "translate(283.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Polygon-Copy-16",
    fill: "url(#linearGradient-1)",
    points: "40 0 74.6410162 20 74.6410162 60 40 80 5.35898385 60 5.35898385 20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-fees-935844",
    transform: "translate(23.000000, 28.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,8.33333333 L13.25,8.33333333 C13.6638371,8.33333333 14,7.95981905 14,7.5 C14,7.04018095 13.6638371,6.66666667 13.25,6.66666667 L12.5,6.66666667 L12.5,5.83333333 C12.5,5.37351429 12.1638371,5 11.75,5 C11.3361629,5 11,5.37351429 11,5.83333333 L11,6.66666667 C9.34562857,6.66666667 8,8.16180952 8,10 C8,11.8381905 9.34562857,13.3333333 11,13.3333333 C11.82734,13.3333333 12.5,14.0807333 12.5,15 C12.5,15.9192667 11.82734,16.6666667 11,16.6666667 L8.75,16.6666667 C8.33616286,16.6666667 8,17.0390667 8,17.5 C8,17.9609333 8.33616286,18.3333333 8.75,18.3333333 L11,18.3333333 L11,19.1666667 C11,19.6276 11.3361629,20 11.75,20 C12.1638371,20 12.5,19.6276 12.5,19.1666667 L12.5,17.8690476 C13.3926286,17.2916667 14,16.2280952 14,15 C14,13.1618095 12.6543714,11.6666667 11,11.6666667 C10.17266,11.6666667 9.5,10.9192667 9.5,10 C9.5,9.08073333 10.17266,8.33333333 11,8.33333333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,0 C5.60752381,0 0,5.60752381 0,12.5 C0,19.3924762 5.60752381,25 12.5,25 C19.3924762,25 25,19.3924762 25,12.5 C25,5.60752381 19.3924762,0 12.5,0 Z M12.5,23.3333333 C6.5267619,23.3333333 1.66666667,18.4732381 1.66666667,12.5 C1.66666667,6.5267619 6.5267619,1.66666667 12.5,1.66666667 C18.4732381,1.66666667 23.3333333,6.5267619 23.3333333,12.5 C23.3333333,18.4732381 18.4732381,23.3333333 12.5,23.3333333 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7555796,10.9446262 L32.755795,6.23044918 C32.4299139,5.92318361 31.9031556,5.92318361 31.5776553,6.23044918 C31.2517741,6.53771474 31.2517741,7.03438247 31.5776553,7.34128886 L35.1548345,10.7144845 L28.8332974,10.7144845 C28.372384,10.7144845 28,11.066647 28,11.5001807 C28,11.9337144 28.372384,12.2858769 28.8332974,12.2858769 L35.1548345,12.2858769 L31.5776553,15.6587134 C31.2517741,15.9659789 31.2517741,16.4626467 31.5776553,16.7695531 C31.7398484,16.9228312 31.953382,17 32.1665443,17 C32.3797065,17 32.5932401,16.922833 32.7558046,16.7699033 L37.7555891,12.0557263 C38.0814703,11.7484607 38.0814703,11.251793 37.7555891,10.9445274 L37.7555796,10.9446262 Z",
    id: "Path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatFee);
export default __webpack_public_path__ + "static/media/flat-fee.c8dc566aa7d9d01cc52bc041f798ba6e.svg";
export { ForwardRef as ReactComponent };